import { Box, Flex, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';

import SkeletonComponent from 'UiKit/skeleton';
import { Iteration } from 'Component/others';

import styles from './styles.module.css';

const DetailWinnerListSkeleton = () => (
  <Box>
    <Flex gap="20px" padding="12px" background="var(--color-semantic-background)" marginBottom="10px" height="80px" alignItems="center">
      <SkeletonComponent height="56px" width="56px" borderRadius="4px" flexShrink={0} />
      <Flex flexDirection="column" gap="8px" flex={1}>
        <SkeletonComponent height="18px" width="40%" />
        <Flex gap="8px">
          <Box minWidth="159px">
            <SkeletonComponent height="14px" width="50%" mb="4px" />
            <SkeletonComponent height="16px" width="70%" />
          </Box>
          <Box minWidth="159px">
            <SkeletonComponent height="14px" width="40%" mb="4px" />
            <SkeletonComponent height="16px" width="30%" />
          </Box>
        </Flex>
      </Flex>
    </Flex>

    <Box className={styles['table-skeleton__container']} border="1px solid var(--color-semantic-outline)">
      <Table className={styles['table__skeleton']}>
        <Thead>
          <Tr>
            <Th className={styles['skeleton__head']} width="90px">
              <SkeletonComponent height="18px" width="60%" />
            </Th>
            <Th className={styles['skeleton__head']} width="150px">
              <SkeletonComponent height="18px" width="70%" />
            </Th>
            <Th className={styles['skeleton__head']} width="90px">
              <SkeletonComponent height="18px" width="80%" />
            </Th>
            <Th className={styles['skeleton__head']} width="272px">
              <SkeletonComponent height="18px" width="50%" />
            </Th>
            <Th className={styles['skeleton__head']} width="150px">
              <SkeletonComponent height="18px" width="50%" />
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          <Iteration
            items={[1, 2, 3, 4]}
            render={(num) => (
              <Tr key={num}>
                <Td className={styles['skeleton__column']}>
                  <SkeletonComponent height="46px" width="46px" borderRadius="4px" />
                </Td>
                <Td className={styles['skeleton__column']}>
                  <SkeletonComponent height="18px" width="80%" />
                </Td>
                <Td className={styles['skeleton__column']}>
                  <SkeletonComponent height="18px" width="60%" />
                </Td>
                <Td className={styles['skeleton__column']}>
                  <SkeletonComponent height="18px" width="85%" />
                </Td>
                <Td className={styles['skeleton__column']}>
                  <SkeletonComponent height="18px" width="70%" />
                </Td>
              </Tr>
            )}
          />
        </Tbody>
      </Table>
    </Box>
  </Box>
);

export default DetailWinnerListSkeleton;
